import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap, withLatestFrom, exhaustMap, concatMap, exhaust, filter } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { Order} from '../../orders/models/orders.models';
import * as manualServicesSelectors from '../store/selectors/manual-services.selectors';
import * as manualServicesActions from '../store/actions/manual-services.actions';
import { ManualServicesServerService } from '../services/manual-services.services';
import { CalculatedRouteModalComponent } from 'src/app/features/orders-create/components/calculated-route-modal/calculated-route-modal.component';
import * as authActions from '../../auth/store/actions/auth.action';
import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import * as filterActions from 'src/app/core/filters/store/actions/filter.action';
import * as filterSelectors from 'src/app/core/filters/store/selectors/filter.selector';
import { CalculatedRouteModalService } from 'src/app/features/manual-services/components/calculated-route-modal/calculated-route-modal.service';


@Injectable()
export class ManualServicesEffects {
  private dialogRef: MatDialogRef<CalculatedRouteModalComponent>;
    constructor(
        private actions$: Actions,
        private manualService: ManualServicesServerService,
        private store: Store<{ order: Order }>,
        private toastr: ToastrService,
        private router: Router,
        private dialog: MatDialog,
        private calculatedRoute: CalculatedRouteModalService,
    ) {}

    loadManualServices$ = createEffect(() =>
        this.actions$.pipe(
            ofType(manualServicesActions.loadManualServices),
            withLatestFrom(this.store.pipe(select(filterSelectors.selectAllFilters))),
            exhaustMap(([action, filters]) => {
                return this.manualService.getManualOrders( filters ).pipe(
                    map(orders => manualServicesActions.loadManualServicesSuccess({ orders })),
                    catchError((error) => {
                        this.toastr.error('No se pudieron cargar los servicios manuales por rider');
                        return of(manualServicesActions.loadManualServicesFailure({ error }));
                    })
                );
            })
        )
      );

      createManualOrder$ = createEffect(() =>
          this.actions$.pipe(
            ofType(manualServicesActions.createManualOrder),
            withLatestFrom(this.store.pipe(select(manualServicesSelectors.selectManualService))),
            mergeMap(([action, order]) =>
              this.manualService.createManualOrder(order).pipe(
                map(order => {
                  this.toastr.success('Servicio creado exitosamente');
                  return manualServicesActions.createManualOrderSuccess({ manualOrder: order });
                }),
                catchError(error => {
                  this.toastr.error('Error creando el servicio, verficar los datos ingresados');
                  return of(manualServicesActions.createManualOrderFailure({ error }));
                })
              )
            )
          )
        );
      
        createManualOrderSuccess$ = createEffect(() =>
          this.actions$.pipe(
            ofType(manualServicesActions.createManualOrderSuccess),
            map(() => {
              this.router.navigate(['/manual-services']);
              return manualServicesActions.loadManualServices();
            })
          )
        );

        
          calculateManualOrderRoute$ = createEffect(() => this.actions$.pipe(
            ofType(manualServicesActions.calculateManualOrderRoute),
           
            withLatestFrom(this.store.pipe(select(manualServicesSelectors.selectManualService))),
            mergeMap(([action, manualOrder]) => {
              return this.manualService.calculateRoute(manualOrder).pipe(
               
                map(calculatedOrderRoute => manualServicesActions.calculateManualOrderRouteSuccess({ calculatedOrderRoute })),
                catchError(error => {

                  console.error('Server error:', error);
                  return of(manualServicesActions.calculateManualOrderRouteFailure({ error }));
                })
              );
            })
          ));

        //   calculateOrderRouteSuccess$ = createEffect(() =>
        //   this.actions$.pipe(
        //     ofType(manualServicesActions.calculateManualOrderRouteSuccess),
        //     tap((action) => {
        //       const dialogRef = this.calculatedRoute.openDialog();
             
        //          dialogRef.afterClosed().subscribe(result => {
                  
        //            if (result === 'accept') {
        //              this.store.dispatch(manualServicesActions.createManualOrder());
        //            }
        //          });
        //     })
        //   ),
        //   { dispatch: false }
        // );

         updateManualOrder$ = createEffect(() =>
          this.actions$.pipe(
            ofType(manualServicesActions.updateManualOrder),
           
          ),
          { dispatch: false }
        );

         loadVehicleTypes$ = createEffect(() => this.actions$.pipe(
            ofType(manualServicesActions.loadVehicleTypes),
            exhaustMap(() =>
              this.manualService.getVehicleTypes().pipe(
                map(vehicleTypes => manualServicesActions.loadVehicleTypesSuccess({ vehicleTypes })),
                catchError(error => {
                  this.toastr.error('Error cargando los tipos de vehículos');
                  return of(manualServicesActions.loadVehicleTypesFailure({ error }));
                })
              ))
          ));

           editOrder$ = createEffect(() =>
              this.actions$.pipe(
                ofType(manualServicesActions.editOrder),
                withLatestFrom(this.store.pipe(select(manualServicesSelectors.selectManualService))),
                mergeMap(([action, order]) =>
                  this.manualService.editOrder(order.id, order).pipe( // Asegúrate de que `action.id` exista y sea el ID correcto a pasar
                    map(manualOrder => {
                      this.toastr.success('Servicio editado exitosamente');
                      this.router.navigate(['/manual-services']);
                      return manualServicesActions.editOrderSuccess({ manualOrder });
                    }),
                    catchError(error => {
                      this.toastr.error('Error editando el servicio, verificar los datos ingresados');
                      return of(manualServicesActions.editOrderFailure({ error }));
                    })
                  )
                )
              )
            );

          cancelOrder$ = createEffect(() =>
              this.actions$.pipe(
                ofType(manualServicesActions.cancelOrder),
                mergeMap(action =>
                  this.manualService.cancelOrder(action.order_id).pipe(
                    map(manualOrder => { 
                      this.toastr.success(`Servicio ${action.order_id} eliminado exitosamente`);
                      return manualServicesActions.cancelOrderSuccess({ manualOrder }); 
                    }),
                    catchError(error => {
                      this.toastr.error(`Error cancelando el servicio ${action.order_id}`);
                      return of(manualServicesActions.cancelOrderFailure({ error }));
                    })
                  )
                )
              )
            );
          

         
  }


